var map = {
	"./ALGAEBRICKS/block.png": [
		6062,
		62
	],
	"./AMORIM/block.png": [
		6406,
		406
	],
	"./BAUX ACOUSTIC PULP/block.png": [
		1628,
		628
	],
	"./BIOCHAR/block.png": [
		589,
		589
	],
	"./BIOHM/block.png": [
		9346,
		346
	],
	"./CRUZ FOAM/block.png": [
		8678,
		678
	],
	"./FLUIDSOLIDS/block.png": [
		6057,
		57
	],
	"./HONEXT BOARDS/block.png": [
		768,
		768
	],
	"./KRAFT LIGNIN/block.png": [
		959,
		959
	],
	"./LIGNOSPHERE/block.png": [
		2302,
		302
	],
	"./LIGNOSULFONATE/block.png": [
		8059,
		59
	],
	"./MANGO MATERIALS/block.png": [
		7549,
		549
	],
	"./MIRIUM/block.png": [
		4611,
		611
	],
	"./MOGU/block.png": [
		2694,
		694
	],
	"./NOTPLA PAPER/block.png": [
		5568,
		568
	],
	"./ORGANOSOLV LIGNIN/block.png": [
		9837,
		837
	],
	"./PAPERBARC/block.png": [
		1291,
		291
	],
	"./PAPERFOAM/block.png": [
		2948,
		948
	],
	"./PAPERSTONE/block.png": [
		8598,
		598
	],
	"./PAPTIC/block.png": [
		8309,
		309
	],
	"./POLYSILICON/block.png": [
		1730,
		730
	],
	"./RELEAF/block.png": [
		9908,
		908
	],
	"./RICHLITE/block.png": [
		290,
		290
	],
	"./SCALITE/block.png": [
		2798,
		798
	],
	"./SULAPAC/block.png": [
		1452,
		452
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7148;
module.exports = webpackAsyncContext;